<script>
export default {
  name: 'AppSlider',
  props: { value: Boolean, isChecked: Boolean, small: Boolean },
  methods: {
    valueChanged(e) {
      this.$emit('input', e.target.checked);
    }
  }
};
</script>

<template>
  <label :class="{ small: small }" class="switch">
    <input type="checkbox" :checked="value" @change="valueChanged" />
    <span class="slider"></span>
  </label>
</template>

<style lang="scss" scoped>
.switch {
  margin-right: 8px;
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;

  input {
    opacity: 0;
    width: 0;
    height: 0;

    &:checked + .slider {
      background-color: var(--purple-light-6);
    }

    &:checked + .slider:before {
      background: var(--primary-color-gradient);
      box-shadow: 0 4px 7px #001ddb40;
      transform: translateX(15px);
    }
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--gray-light-3);
    border-radius: 21px;
    transition: 0.4s;

    &:before {
      border-radius: 50%;
      position: absolute;
      content: '';
      height: 16px;
      width: 16px;
      left: 3.5px;
      bottom: 3px;
      background-color: var(--purple-light);
      transition: 0.4s;
    }
  }

  &.small {
    width: 32px;
    height: 17px;

    input:checked + .slider:before {
      transform: translateX(14px);
    }

    .slider:before {
      height: 13px;
      width: 13px;
      left: 2.5px;
      bottom: 2px;
    }
  }
}
</style>
